<template>
    <div class="main noTakeaway orange">
        <Banner :banner="banner"/>
        <Headlines :headlines="headlines"/>

        <div class="content-box">
            <div class="left-box">
                <Article :article="article"/>
                <Article :article="media"/>
                <Article :article="review"/>
                <Project :project="project"/>
            </div>

            <Rightbox/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'alyxl',
    // meta配置
    metaInfo: {
        title: '【专题】' + '阿里云用户数据被泄露 官方权威通报！律师：责任人将面临刑事责任',
        meta: [
            {
                name: 'keywords',
                content: '阿里云 信息泄漏 用户数据'
            },
            {
                name: 'description',
                content: ''
            }
        ]
    },
    data() {
        return {
            // 头图标题
            banner: {
                img: require('@/assets/alyxl/banner3.jpg'),
                title: [
                    '阿里云用户数据被泄露 官方权威通报！',
                    '律师：责任人将面临刑事责任',
                ],
                text: ''
            },

            // 置顶头条
            headlines: [
                {
                    title: '阿里丑闻再曝光 用户数据被泄露 官方权威通报！律师：责任人将面临刑事责任',
                    url: '/detail--6599831.html'
                },
            ],

            // 滚动播报
            article: {
                title: {
                    topic: '最新动态',
                    more: {
                        name: '我要投诉>',
                        url: '/Index/complain.html'
                    }
                },
                params: {
                    p: 1,
                    n: 5,
                    terms: '阿里云'
                },
            },

            // 媒体采用
            media: {
                title: {
                    topic: '媒体采用',
                },
                list: [
                    {
                        title: '《每日商报》：阿里云泄露用户数据现隐忧 个人信息泄露为何屡禁不止？',
                        url: 'https://hzdaily.hangzhou.com.cn/mrsb/2021/08/26/article_detail_3_20210826A137.html',
                        post_date: '2021-08-26'
                    },
                    {
                        title: '《北京日报》：员工违规泄露用户信息，阿里云称已严肃处理',
                        url: 'https://www.bjd.com.cn/huawei/2021/08/25/159341t318.html',
                        post_date: '2021-08-25 17:58'
                    },
                    {
                        title: '《广州日报》：阿里云泄露用户数据现隐忧 个人信息泄露为何屡禁不止？',
                        url: 'https://huacheng.gz-cmc.com/pages/2021/08/24/3449b48bcae4451c89f3817e7edb829b.html?channel=weixin&vTime=27164253',
                        post_date: '2021-08-24 23:19:47'
                    },
                    {
                        title: '中国科技新闻网：阿里云称员工私下泄漏用户信息 专家：其内部管理漏洞是一大隐患',
                        url: 'https://mp.weixin.qq.com/s/t3MTnddxEhWMqq3DPc7G4A',
                        post_date: '2021-08-24'
                    },
                ],
            },

            // 相关平台
            review: {
                title: {
                    topic: '相关平台',
                    more: {
                        name: '企业库>',
                        url: 'http://cop.100ec.cn/'
                    }
                },
                nav: [
                    {
                        value: '京东云',
                        label: '京东云'
                    },
                    {
                        value: '百度云',
                        label: '百度云'
                    },
                    {
                        value: '华为云',
                        label: '华为云'
                    },
                    {
                        value: '天翼云',
                        label: '天翼云'
                    },
                    {
                        value: '金山云',
                        label: '金山云'
                    },
                    {
                        value: '浪潮云',
                        label: '浪潮云'
                    },
                    {
                        value: '新华三',
                        label: '新华三'
                    },
                    {
                        value: '青云',
                        label: '青云'
                    },
                ],
                params: {
                    p: 1,
                    n: 3,
                    terms: '京东云'
                },
            },

            // 相关专题
            project: {
                title: {
                    topic: '相关专题',
                },
                params: {
                    p: 1,
                    name: '',
                    title: '泄露'
                },
            }
        }
    },
}
</script>

<style>

</style>
